import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
declare var JitsiMeetExternalAPI: any;
import { v4 as uuidv4 } from 'uuid';
import { UserHelperService } from '@helpers/user-helper.service';
import { environment } from '@environments/environment';
import { UserPreferencesService } from '@modules/users/user.preferences.service';

@Component({
  selector: 'app-jitsi',
  templateUrl: './jitsi.component.html',
  styleUrls: ['./jitsi.component.scss'],
})
export class JitsiComponent implements OnInit, AfterViewInit, OnDestroy {
  private domain: string = environment.OMNISMART_API_JITSI_MEET.replace(/(^\w+:|^)\/\//, '');
  private room: any;
  private options: any;
  private api: any;
  private user: any;

  public isAudioMuted: boolean = false;
  public isVideoMuted: boolean = false;
  public minimized: boolean = false;
  public frameId: string = 'jitsi-iframe';

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      handleVideoConferenceJoined?: (participant, participants) => void;
      handleVideoConferenceLeft?: (participant, participants) => void;
      handleParticipantJoined?: (participant, participants) => void;
      handleParticipantLeft?: (participant, participants) => void;
      room?: string;
    },
    private readonly userHelperService: UserHelperService,
    private readonly userPreferencesService: UserPreferencesService
  ) {
    this.room = this.data?.room ?? 'omnismart-' + uuidv4();

    this.frameId = `jitsi-iframe-${this.room}`;
  }

  async ngOnInit() {
    this.user = this.userHelperService.getUserAttributes()!;
  }

  async ngAfterViewInit() {
    const language = await this.userPreferencesService.getLanguage();

    this.options = {
      lang: language?.flagJitsi ?? language?.flag ?? 'ptBR',
      roomName: this.room,
      width: '75vw',
      height: '80vh',
      parentNode: document.querySelector(`#${this.frameId}`),
      userInfo: {
        displayName: this.user.name,
        email: this.user.email,
      },
    };

    this.api = new JitsiMeetExternalAPI(this.domain, this.options);

    this.api.addEventListeners({
      readyToClose: this.handleClose,
      videoConferenceJoined: this.handleVideoConferenceJoined,
      videoConferenceLeft: this.handleVideoConferenceLeft,
      participantJoined: this.handleParticipantJoined,
      participantLeft: this.handleParticipantLeft,
      audioMuteStatusChanged: this.handleMuteStatus,
      videoMuteStatusChanged: this.handleVideoStatus,
    });

    this.api.executeCommand('avatarUrl', this.user.picture);

    this.isAudioMuted = await this.api.isAudioMuted();
    this.isVideoMuted = await this.api.isVideoMuted();
  }

  ngOnDestroy(): void {
    this.api.executeCommand('hangup');
    this.api.removeListener('readyToClose', this.handleClose);
    this.api.removeListener('videoConferenceJoined', this.handleVideoConferenceJoined);
    this.api.removeListener('videoConferenceLeft', this.handleVideoConferenceLeft);
    this.api.removeListener('participantJoined', this.handleParticipantJoined);
    this.api.removeListener('participantLeft', this.handleParticipantLeft);
    this.api.removeListener('audioMuteStatusChanged', this.handleMuteStatus);
    this.api.removeListener('videoMuteStatusChanged', this.handleVideoStatus);
    this.api.dispose();
  }

  handleClose = async (data) => {};

  handleVideoConferenceJoined = async (participant) => {
    if (this.data.handleVideoConferenceJoined) {
      const participantsCount = await this.getParticipantsCount();

      this.data.handleVideoConferenceJoined(participant, participantsCount);
    }
  };

  handleVideoConferenceLeft = async (participant) => {
    if (this.data.handleVideoConferenceLeft) {
      const participantsCount = await this.getParticipantsCount();

      this.data.handleVideoConferenceLeft(participant, participantsCount);
    }

    this.dialogRef.close(false);
  };

  handleParticipantJoined = async (participant) => {
    if (this.data.handleParticipantJoined) {
      const participantsCount = await this.getParticipantsCount();

      this.data.handleParticipantJoined(participant, participantsCount);
    }
  };

  handleParticipantLeft = async (participant) => {
    if (this.data.handleParticipantLeft) {
      const participantsCount = await this.getParticipantsCount();

      this.data.handleParticipantLeft(participant, participantsCount);
    }
  };

  handleMuteStatus = (audio) => {
    this.isAudioMuted = audio.muted;
  };

  handleVideoStatus = (video) => {
    this.isVideoMuted = video.muted;
  };

  getParticipantsCount() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.api.getNumberOfParticipants());
      }, 500);
    });
  }

  executeCommand(command: string) {
    this.api.executeCommand(command);

    if (command == 'toggleAudio') {
      this.isAudioMuted = !this.isAudioMuted;
    }

    if (command == 'toggleVideo') {
      this.isVideoMuted = !this.isVideoMuted;
    }
  }

  public close() {
    this.api.executeCommand('hangup');
    this.dialogRef.close();
  }

  public toggleMinimized() {
    this.minimized = !this.minimized;
  }
}
